/**
 * Generic image lightbox: open images in a modal <dialog> with prev/next nav.
 *
 * Markup contract per gallery container (data-lightbox-gallery):
 *   - One or more [data-lightbox-trigger] elements with:
 *       data-index, data-full-src, data-srcset (optional), data-alt (optional)
 *       For video slides: data-media-type="video", data-video-src, data-poster-src (optional)
 *   - One [data-lightbox] <dialog> containing:
 *       [data-lightbox-img], [data-lightbox-video] (optional), [data-lightbox-counter],
 *       [data-lightbox-close], [data-lightbox-prev], [data-lightbox-next]
 */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-lightbox-init') === '1') return;

    var dialog = root.querySelector('[data-lightbox]');
    var img = dialog && dialog.querySelector('[data-lightbox-img]');
    var video = dialog && dialog.querySelector('[data-lightbox-video]');
    var counter = dialog && dialog.querySelector('[data-lightbox-counter]');
    var closeBtn = dialog && dialog.querySelector('[data-lightbox-close]');
    var prevBtn = dialog && dialog.querySelector('[data-lightbox-prev]');
    var nextBtn = dialog && dialog.querySelector('[data-lightbox-next]');
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox-trigger]'));

    if (!dialog || !img || !triggers.length) return;

    triggers.sort(function (a, b) {
      return (+a.getAttribute('data-index') || 0) - (+b.getAttribute('data-index') || 0);
    });

    var slides = triggers
      .map(function (btn) {
        var mediaType = btn.getAttribute('data-media-type') || 'image';
        if (mediaType === 'video') {
          return {
            type: 'video',
            videoSrc: btn.getAttribute('data-video-src') || '',
            posterSrc: btn.getAttribute('data-poster-src') || '',
            alt: btn.getAttribute('data-alt') || '',
          };
        }
        return {
          type: 'image',
          src: btn.getAttribute('data-full-src'),
          srcset: btn.getAttribute('data-srcset') || '',
          alt: btn.getAttribute('data-alt') || '',
        };
      })
      .filter(function (s) {
        return s.type === 'video' ? s.videoSrc : s.src;
      });

    if (!slides.length) return;

    root.setAttribute('data-lightbox-init', '1');

    var current = 0;
    var lastFocus = null;

    function setNavVisibility() {
      var multi = slides.length > 1;
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;
      if (counter) counter.hidden = !multi;
    }

    function pauseVideo() {
      if (!video) return;
      video.pause();
      video.removeAttribute('src');
      video.removeAttribute('poster');
      video.load();
      video.hidden = true;
    }

    function show(index) {
      current = ((index % slides.length) + slides.length) % slides.length;
      var slide = slides[current];

      if (slide.type === 'video' && video) {
        img.hidden = true;
        img.removeAttribute('src');
        img.removeAttribute('srcset');
        video.hidden = false;
        if (slide.posterSrc) {
          video.setAttribute('poster', slide.posterSrc);
        } else {
          video.removeAttribute('poster');
        }
        video.muted = true;
        video.src = slide.videoSrc;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        pauseVideo();
        img.hidden = false;
        img.src = slide.src;
        if (slide.srcset) {
          img.setAttribute('srcset', slide.srcset);
        } else {
          img.removeAttribute('srcset');
        }
        img.alt = slide.alt;
      }

      if (counter) {
        counter.textContent = current + 1 + ' / ' + slides.length;
      }
    }

    function onDocumentKeydown(event) {
      if (!dialog.open) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (slides.length < 2) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(current - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(current + 1);
      }
    }

    function open(index) {
      lastFocus = document.activeElement;
      show(index);
      setNavVisibility();
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      document.addEventListener('keydown', onDocumentKeydown);
      if (typeof dialog.focus === 'function') {
        dialog.focus();
      }
    }

    function close() {
      document.removeEventListener('keydown', onDocumentKeydown);
      pauseVideo();
      if (dialog.open) {
        dialog.close();
      }
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(+btn.getAttribute('data-index') || 0);
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(current + 1);
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-lightbox-img], [data-lightbox-video], [data-lightbox-close], [data-lightbox-prev], [data-lightbox-next]')) {
        return;
      }
      close();
    });

    dialog.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lightbox-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
